import JobLogType from 'src/models/job-logger/JobLogType'
import Model, { encoders, ID, IsoDateTime } from 'src/models/model'

export default class JobLog extends Model {
  static name = 'JobLog'

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      jobLogType: {
        type: JobLogType,
        encode: encoders.hasOne,
        reference: true
      },
      jobLogSubType: {
        type: JobLogType,
        encode: encoders.hasOne,
        reference: true
      },
      startTime: {
        type: IsoDateTime,
        sortable: true,
        output: true
      },
      endTime: {
        type: IsoDateTime,
        sortable: true,
        output: true
      },
      state: {
        type: String,
        output: true
      },
      summary: {
        type: String,
        output: true
      },
      log: {
        type: String,
        output: true
      }
    }
    this.paginate = true
  }
}
